// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__JWVtA","icon":"SortAdornment_icon__26olQ","up":"SortAdornment_up__2K9w1","down":"SortAdornment_down__2F8Bo","active":"SortAdornment_active__3e21F"};